import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSatisfiedSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24.87 16.46a.772.772 0 0 0-.15-.02c-.35 0-.66.24-.73.6-.08.41.18.8.58.89 4.26.89 5.2 5.29 5.24 5.48.07.35.38.6.73.6h.04c.37-.02.67-.3.71-.67.01-.08.65-5.83 4.25-10.37-.35-.37-.72-.72-1.11-1.05-2.39 2.95-3.58 6.35-4.15 8.64-.89-1.62-2.52-3.5-5.41-4.1Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M39.25 8c.26 0 .51.14.65.38.21.36.08.82-.28 1.02-7.25 4.14-8.32 13.83-8.33 13.93a.75.75 0 0 1-.71.67h-.04c-.35 0-.66-.25-.73-.6-.04-.19-.98-4.59-5.24-5.48a.74.74 0 0 1-.58-.89c.07-.35.39-.6.73-.6.05 0 .1.01.15.02 2.88.6 4.52 2.48 5.42 4.09.84-3.42 3.05-9.29 8.59-12.45.11-.06.24-.09.37-.09Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M36.55 14.11c-3.14 4.12-3.76 9.3-3.76 9.37-.11 1.11-1.01 1.96-2.16 2.02h-.08c-1.06 0-1.99-.76-2.2-1.8-.03-.15-.78-3.62-4.08-4.31-1.21-.25-2-1.45-1.74-2.66a2.256 2.256 0 0 1 2.2-1.79c.16 0 .31.02.46.05 1.97.41 3.44 1.32 4.53 2.36.74-1.99 1.88-4.27 3.57-6.36C30.65 9.12 27.46 8 24 8 15.18 8 8 15.18 8 24s7.18 16 16 16 16-7.18 16-16c0-3.73-1.3-7.16-3.45-9.89Zm-6.14 16.26c-1.63 1.6-4 2.51-6.5 2.51h-.21c-2.42-.05-4.66-.97-6.12-2.53-.28-.3-.27-.78.03-1.06.3-.29.77-.27 1.06.03 1.19 1.27 3.04 2.02 5.06 2.06 2.19.03 4.24-.71 5.63-2.08.29-.29.77-.29 1.06.01.29.3.28.77-.01 1.06Z",
    fill: "currentColor"
  }));
}

export { SvgSatisfiedSelectedEmojiSecondary as default };
